import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { nucleus } from "./NucleusTheme";

export class TopRightLogo extends PureComponent {
    render() {
        return (
            <LogoContainer>
                <Logo data-testid="logo-image" src={this.props.logo || nucleus.logo} />
            </LogoContainer>
        );
    }
}

const LogoContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
`;

export const Logo = styled.img`
    max-height: 119px;
    max-width: 190px;
`;

TopRightLogo.propTypes = {
    logo: PropTypes.string
};
